import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';

const WalkCorran = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity("CORRAN"));
  }

  return (
    <div>
      <h2 className="walks-link-heading"><a  onClick={navigateToActivity}>Corran</a></h2>
      <p className="walk-text">Beautiful walk along the quiet road to the end of the line at the village of Corran.  You can walk back over the headland and along the beach.
      </p>   
    </div>
  );
}

export default WalkCorran
